import { render, staticRenderFns } from "./InviteFriends.vue?vue&type=template&id=6a4a2880&scoped=true&"
import script from "./InviteFriends.vue?vue&type=script&lang=js&"
export * from "./InviteFriends.vue?vue&type=script&lang=js&"
import style0 from "./InviteFriends.vue?vue&type=style&index=0&id=6a4a2880&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4a2880",
  null
  
)

export default component.exports